import type { EntityState, EntityAdapter } from 'redux-ngrx-entity';
import { createEntityAdapter } from 'redux-ngrx-entity';
import type { Note, NotesFilter } from '../../core/models/notes';

export interface NotesState extends EntityState<Note> {
  selected: string | undefined | null;
  createLocationText: string;
  dateRange: [Date, Date];
  filter: NotesFilter;
  currentSelectedNote: string | undefined;
  createFieldId: string | null;
  noteDashboard: string | undefined;
}

export const adapter: EntityAdapter<Note> = createEntityAdapter<Note>();
